import {
  ClientMessage,
  NotebookDataResultsMessage,
  ServerMessage
} from '@convergence/types';
import React from 'react';
import { z } from 'zod';
import { WebSocketClient } from '../lib/WebSocketClient';
import { API_ENDPOINT } from '../lib/api';

interface NotebookTestProps {}

export const NotebookTest: React.FC<NotebookTestProps> = ({}) => {
  const results: z.infer<typeof NotebookDataResultsMessage>[] = [];
  const clicked = () => {
    const ws = new WebSocketClient({ url: API_ENDPOINT.replace('http', 'ws') });
    ws.onMessage(ServerMessage.socketReady, () => {
      console.log('socket ready');
      ws.onMessage(ServerMessage.connectionCreated, () => {
        console.log('connected to tinkerbox');

        ws.onMessage(ServerMessage.notebookDataResults + '1', (data) => {
          const validated = NotebookDataResultsMessage.safeParse(data);
          if (validated.success) {
            console.log('valid response');
            results.push(validated.data);
          }
          console.log('invalid response');
        });

        ws.onMessage(ServerMessage.notebookDataFinished + '1', () => {
          console.log('notebook data finished');
          console.log(results);
        });

        ws.sendMessage({
          event: ClientMessage.notebookData,
          data: JSON.stringify({
            command: 'echo "Hello world"\n',
            id: '1'
          })
        });
      });
      ws.sendMessage({
        event: ClientMessage.tinkerBoxConnect,
        data: {
          tinkerBoxId: 48,
          rows: 0,
          cols: 0
        }
      });
    });
  };

  return (
    <div>
      <button onClick={() => clicked()}>click me</button>
      <pre>{JSON.stringify(results, null, 2)}</pre>
    </div>
  );
};
